module.exports = __webpack_public_path__ + "img/index04.7f4c9ea8.jpg";